import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";
import Parse from "../../../api/ApiConfig";
import { RequestStatusFormWrapper } from "../../../components/common/RequestStatusForm.styled";
import { SelectField, TextAreaField } from "../../../components/Form/FormComponents";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { setLoadingState } from "../../../redux/AppSlice";
import { handleAdminUpdateRequest, onAdminUpdatesRequestStatus } from "../utils";
import { useDispatch } from "react-redux";

const AdminReqStatusForm = ({
	formData,
	adminComments,
	handleInputChange,
	investorData,
	onBeginFundRequest,
}) => {
	const dispatch = useDispatch();

	let { id: objectId } = useParams();

	const currentUser = Parse.User.current();
	const privileges = currentUser.get("privileges");
	const role = currentUser.get("role");

	const [approvalState, setApprovalState] = useState("");

	const userCheck = () => {
		if (privileges === "admin" && role === "Risk & Compliance") {
			return privileges;
		}
		if (privileges === "firstLineApproval" && role === "Risk & Compliance") {
			return privileges;
		}
		if (privileges === "secondLineApproval" && role === "Risk & Compliance") {
			return privileges;
		}
		if (privileges === "finalApproval" && role === "Risk & Compliance") {
			return privileges;
		}
		if (privileges === "admin" && role === "Finance") {
			return privileges + "Finance";
		}
		if (privileges === "firstLineApproval" && role === "Finance") {
			return privileges + "Finance";
		} else {
			return "all";
		}
	};

	const isRejectRequest = adminComments
		?.filter((c) => !c.status?.includes("Recommend"))
		?.find((a) => a?.status?.includes("Reject"));

	const approvalStatusCheck = () => {
		if (isRejectRequest) {
			return true;
		}
		if (userCheck() === "admin" && formData?.basicAdminApproval?.status) {
			return true;
		}
		if (userCheck() === "firstLineApproval" && formData?.firstLineApproval?.status) {
			return true;
		}
		if (userCheck() === "secondLineApproval" && formData?.secondLineApproval?.status) {
			return true;
		}
		if (userCheck() === "finalApproval" && formData?.finalApproval?.status) {
			return true;
		}
		//first admin guy
		if (userCheck() === "adminFinance" && formData?.financeApproval?.status) {
			return true;
		}

		//final guy,
		if (userCheck() === "firstLineApprovalFinance" && formData?.approvalStatus !== "pending") {
			return true;
		}

		if (formData?.approvalStatus === "rejected") {
			return true;
		}

		// if (formData?.approvalStatus === "approved" || formData?.approvalStatus === "approved") {
		// 	return true;
		// }
		if (userCheck === "all") {
			return false;
		} else {
			return false;
		}
	};

	const setApprovalMessage = () => {
		// if any admin rejects request
		if (isRejectRequest) {
			return (
				<p style={{ fontWeight: "600" }}>
					{isRejectRequest?.admin} has rejected this request. Check approval status for comment.
				</p>
			);
		}
		//need the funded column
		if (formData?.approvalStatus === "rejected" || formData?.approvalStatus === "reject") {
			return <p>Finance Request has been rejected</p>;
		} else if (formData?.approvalStatus === "approved" && !formData?.funded) {
			return (
				<>
					<p style={{ fontWeight: "600", marginTop: "1.5rem" }}>
						Finance Request has been approved and is awaiting funding from the finance department (First Line
						Admin).
					</p>
					{userCheck() === "firstLineApprovalFinance" && (
						<Button variant='contained' sx={{ width: "auto" }} onClick={onBeginFundRequest}>
							Fund Request
						</Button>
					)}
				</>
			);
		} else if (formData?.approvalStatus === "pending" && formData?.investorFinanceInfo) {
			return (
				<p style={{ fontWeight: "600", marginTop: "1.5rem" }}>
					Request has already been funded. Approval required.
				</p>
			);
		} else if (formData?.funded) {
			return (
				<p style={{ fontWeight: "600", marginTop: "1.5rem" }}>Finance Request has been approved and funded</p>
			);
		} else {
			return null;
		}
	};

	const handleApprovalState = (e) => {
		setApprovalState(e.target.value);
	};

	const updateStatus = async () => {
		if (!formData?.requestComment || !approvalState) {
			toast.error("Please  add a comment and select an action!");
			return;
		}
		if (userCheck() === "firstLineApproval" && !formData?.basicAdminApproval?.status) {
			toast.error("Finance Request has not been recommended for approval by admin");
			return;
		}
		if (userCheck() === "secondLineApproval" && !formData?.firstLineApproval?.status) {
			toast.error("Finance Request has not been recommended for approval by first line admin");
			return;
		}
		if (userCheck() === "finalApproval" && !formData?.secondLineApproval?.status) {
			toast.error("Finance Request has not been recommended for approval by second line  admin");
			return;
		}
		if (userCheck() === "adminFinance" && !formData?.finalApproval?.status) {
			toast.error(
				"Finance Request has not been recommended for approval by the Risk & Compliance department"
			);
			return;
		}
		if (userCheck() === "firstLineApprovalFinance" && !formData?.financeApproval?.status) {
			toast.error("Finance Request has not been recommended for approval by the basic finance admin");
			return;
		}
		if (userCheck() === "all") {
			toast.error("You are not authorized to approve this request, please contact the finance department");
			return;
		}

		const objKey =
			userCheck() === "admin"
				? "basicAdminApproval"
				: userCheck() === "adminFinance"
				? "financeApproval"
				: userCheck();

		const newData = {
			[objKey]: { status: approvalState, comment: formData?.requestComment },
			approvalStatus:
				userCheck() === "admin"
					? formData?.approvalStatus
					: approvalState?.includes("Reject")
					? "rejected"
					: formData?.approvalStatus,
		};

		const financeFirstLineAdminData = {
			approvalStatus: approvalState?.includes("Reject") ? "rejected" : "approved",
		};

		const flAdminAppOrRejectRequest = () => {
			let allUpdatedRequests = [];

			if (approvalState === "Approve") {
				allUpdatedRequests = investorData?.apprentice?.map((a) => {
					if (a?.transactionId === formData?.objectId) {
						return { id: formData?.objectId, ...newData };
					} else {
						return {
							id: a?.transactionId,
							approvalStatus: "rejected",
							firstLineApproval: {
								status: "Reject",
								comment: "This request has been rejected because another has been approved",
							},
						};
					}
				});
				return allUpdatedRequests;
			} else if (approvalState === "Reject") {
				allUpdatedRequests = [{ id: objectId, ...newData }];
				return allUpdatedRequests;
			}
		};

		const updatedApprenticeArr = () => {
			let apprenticeArr = [];

			if (approvalState === "Approve") {
				apprenticeArr = investorData?.apprentice?.map((a) => {
					if (a?.transactionId === formData?.objectId) {
						return { ...a, status: "approved" };
					} else {
						return { ...a, status: "rejected" };
					}
				});
				return apprenticeArr;
			} else if (approvalState === "Recommend for Approval") {
				return investorData?.apprentice;
			} else if (approvalState === "Reject") {
				apprenticeArr = investorData?.apprentice?.map((a) => {
					if (a?.transactionId === formData?.objectId) {
						return { ...a, status: "rejected" };
					} else {
						return { ...a };
					}
				});
				return apprenticeArr;
			} else if (approvalState === "Recommend for Rejection") {
				return investorData?.apprentice;
			}
		};

		const investorInfo = {
			investors: ["Fortcore Admin"],
			investorsInfo: [
				{
					investorName: "Fortcore Admin",
					investorPhone: currentUser?.get("phone"),
					investorEmail: currentUser?.get("email"),
					investorId: Parse.User.current().id,
					investorAddress: currentUser?.get("homeAddress"),
					amountPaid: formData?.amountToRaise,
				},
			],
		};

		const flAdminAppOrRejRequestOld = [
			{
				id: formData?.objectId,
				finalApproval: { status: approvalState, comment: formData?.requestComment },
				approvalStatus: approvalState?.includes("Reject") ? "rejected" : "approved",
			},
		];

		const flAdminAppOrRejRequestNew = {
			finalApproval: { status: approvalState, comment: formData?.requestComment },
			approvalStatus: approvalState?.includes("Reject") ? "rejected" : "approved",
			...investorInfo,
		};

		const dataToUpdate =
			formData?.requestType === "old" && userCheck() === "firstLineApproval"
				? flAdminAppOrRejectRequest()
				: formData?.requestType === "old" && userCheck() === "finalApproval"
				? flAdminAppOrRejRequestOld
				: userCheck() === "firstLineApprovalFinance"
				? financeFirstLineAdminData
				: userCheck() === "finalApproval" && formData?.requestType === "new"
				? flAdminAppOrRejRequestNew
				: newData;

		const arrayOfObjectsToUpdate = Array.isArray(dataToUpdate)
			? dataToUpdate
			: [{ ...dataToUpdate, id: formData?.objectId }];

		const investorDataToUpdate = updatedApprenticeArr();

		// console.log(arrayOfObjectsToUpdate, investorDataToUpdate, formData);

		try {
			dispatch(setLoadingState(true));

			let response;

			if (formData?.requestType === "old") {
				const financeId = formData?.investorFinanceInfo?.financeId;

				response = await onAdminUpdatesRequestStatus(
					financeId,
					{ apprentice: investorDataToUpdate },
					arrayOfObjectsToUpdate
				);
			} else {
				response = await handleAdminUpdateRequest(objectId, dataToUpdate);
			}

			console.log(response);
			if (response) {
				toast.success("Request status updated successfully!");

				setTimeout(() => {
					location.reload();
				}, 700);

				setTimeout(() => {
					dispatch(setLoadingState(false));
				}, 1500);
			}
		} catch (error) {
			// console.log(error);
			toast.error(error);
			dispatch(setLoadingState(false));
		}
	};

	return (
		<RequestStatusFormWrapper>
			<div className='statusFlow mt-4'>
				<div className={"statusFlow_item " + (formData?.financeAgreement ? "done" : "")}>
					{formData?.financeAgreement ? "Finance Agreement Signed" : "Awaiting Finance Agreement"}
				</div>
				{formData?.requestType === "old" && (
					<div className={"statusFlow_item " + (formData?.commitmentFeeStatus === "paid" ? "done" : "")}>
						{formData?.commitmentFeeStatus === "paid"
							? "Commitement Fee Paid"
							: "Awaiting Commitment Fee Payment"}
					</div>
				)}
				{formData?.requestType === "new" && (
					<div className={"statusFlow_item " + (formData?.funded ? "done" : "")}>
						{formData?.funded ? "Finance Request has been Funded" : "Awaiting Request Funding"}
					</div>
				)}

				{formData?.requestType === "new" && (
					<div className={"statusFlow_item " + (formData?.financeApproval?.status ? "done" : "")}>
						Awaiting Admin Approval (Finance)
					</div>
				)}
				<div className={"statusFlow_item " + (formData?.finalApproval?.status ? "done" : "")}>
					Awaiting Final Line Approval(Risk & Compliance)
				</div>
				<div className={"statusFlow_item " + (formData?.secondLineApproval?.status ? "done" : "")}>
					Awaiting second line approval (Risk & Compliance)
				</div>
				<div
					className={
						"statusFlow_item " + (formData?.firstLineApproval?.status || isRejectRequest ? "done" : "")
					}>
					Awaiting first line approval (Risk & Compliance)
				</div>
				<div
					className={
						"statusFlow_item " + (formData?.basicAdminApproval?.status || isRejectRequest ? "done" : "")
					}>
					Awaiting Risk & Compliance Admin Recommendation
				</div>
				{formData?.requestType === "old" && (
					<div className={"statusFlow_item " + (formData?.investorFinanceInfo ? "done" : "")}>
						{formData?.investorFinanceInfo ? "Finance Request has been Funded" : "Awaiting Request Funding"}
					</div>
				)}
				{formData?.requestType === "new" && (
					<div className={"statusFlow_item " + (formData?.commitmentFeeStatus === "paid" ? "done" : "")}>
						{formData?.commitmentFeeStatus === "paid"
							? "Commitment Fee Paid"
							: "Awaiting Commitment Fee Payment"}
					</div>
				)}
				<div className='statusFlow_item done'>Request Submitted</div>
				<div className='statusFlow_item done'>Credit Assessment</div>
				<div className='statusFlow_item done'>Guarantor Information Submitted</div>
				<div className='statusFlow_item done'>Auto Debit</div>
			</div>

			<div className='w-1-2'>
				<div className='form-group'>
					{setApprovalMessage()}

					<SelectField
						name=''
						handleChange={handleApprovalState}
						isEditable={!approvalStatusCheck()}
						value={approvalState}
						placeholder={"-- Action --"}
						options={
							userCheck() === "admin"
								? ["Recommend for Approval", "Recommend for Rejection"]
								: userCheck() === "adminFinance"
								? ["Approve for Financing", "Reject for Financing"]
								: ["Approve", "Reject"]
						}
					/>
				</div>
				{/* || userCheck() === "adminFinance" */}
				<div className='form-group'>
					<TextAreaField
						name='requestComment'
						handleChange={handleInputChange}
						isEditable={!approvalStatusCheck()}
						value={formData?.requestComment}
						placeholder={"Write a comment"}
					/>
				</div>

				<Button
					disabled={approvalStatusCheck()}
					variant='contained'
					color='primary'
					onClick={updateStatus}
					sx={{ mt: 2.5, px: 5 }}>
					Submit
				</Button>
				{/* //check if admins has approved */}

				{/* // remianing finance approval and super admin */}
			</div>
		</RequestStatusFormWrapper>
	);
};

AdminReqStatusForm.propTypes = {
	formData: PropTypes.object,
	adminComments: PropTypes.array,
	handleInputChange: PropTypes.func,
	onBeginFundRequest: PropTypes.func,
	investorData: PropTypes.object,
};

export default AdminReqStatusForm;
